import lodash from 'lodash'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import HazmatLabel from '../../../../../../components/Hazmat/HazmatLabel'

const Wrapper = styled.div``

const HazmatLabels = (props) => {
  const {} = props

  const identificationMarkings = useField('identificationMarkings')
  const environmentalHazard = useField('environmentalHazard')

  const labels = useMemo(() => {
    const result = [...identificationMarkings]
    if (environmentalHazard) {
      result.push('env')
    }
    return result.filter(Boolean)
  }, [identificationMarkings, environmentalHazard])

  if (lodash.isEmpty(labels)) {
    return null
  }

  return (
    <Wrapper>
      <Label>{i18n.t('hazmat_labels', 'Gefahrgutlabels')}</Label>
      <div>
        {lodash.map(labels, (label) => (
          <div className="mr-1 d-inline-block">
            <HazmatLabel label={label} display="block" size={30} />
          </div>
        ))}
      </div>
    </Wrapper>
  )
}

export default HazmatLabels
